import { useEffect, useMemo, useState } from "react";
import styles from "./ExploreReplayColumnUpgrade.module.scss";
import { useGetPlansQuery } from "@/features/auth/api/authAPI";

const seededRandom = (seed) => {
  const x = Math.sin(seed) * 10000;
  return x - Math.floor(x);
};

const ExploreReplayColumnUpgrade = ({
    screens,
    handleOpenBillingPage,
    rowIndex,
}: {
    screens: any[],
    handleOpenBillingPage: () => void,
    rowIndex: number,
}) => {


    const [monthlyPrice, setMonthlyPrice] = useState();

    const { data: apiDataPlans } = useGetPlansQuery();    

    useEffect(() => {
        if (apiDataPlans) {
            const plan = apiDataPlans[0];
            const {
                recurring_interval_count,
                unit_amount,
            } = plan;
      
            const priceValue = (unit_amount / 100 / recurring_interval_count)
            setMonthlyPrice(priceValue);
        }
    }, [apiDataPlans]);

    const PaywallTexts = [
    "Unlock These Screens Now",
    "See the Full Flow: Go Pro",
    "Get Full Library Access",
    "Access Insights from 1700+ Apps",
    "See What Converts: Go Pro",
    "Unlock Top App Strategies",
    "Level Up Your App Design",
    "Get Your Competitor Edge",
    "Buy good tools to give you the advantage",
    "Pro Members See Everything",
    "Member-Only Design Access",
    "See How Top Apps Do It: Go Pro",
    "What's Behind the Blur? Upgrade",
    "Upgrade to See Full Screen",
    "Go Pro for Complete Details",
    "Analyze This App's Paywall Strategy",
    "Unlock Full UI Flow Analysis",
    "Compare Top App UI Patterns",
    "Stop Guessing: See Real Examples",
    "Get Design Inspiration & Data",
    "The Secret Sauce is Behind Here (Pro Access)",
    "Design Cheat Codes Unlocked (Go Pro)",
    "Peek Behind the Design Curtain",
    "Beyond Pixels: Unlock Strategic Insights",
    "Fuel Your Next Breakthrough Design",
    "Become a conversion powerhouse",
    "Save 200 hours and design top converting screens"
    ]

    const randomText = useMemo(() => {
        const randomIndex = Math.floor(seededRandom(rowIndex) * PaywallTexts.length);
        return PaywallTexts[randomIndex];
    }, [rowIndex]);

    return (
        <div className={`${styles.unlockProContainer}`}>
            <div className={styles.photo}>
                <div className={styles.photoContainer}>
                <img
                    className={styles.unlockProItem}
                    src="/img/unlockProItemIcon.svg"
                    alt="unlockProItem"
                />
                <div className={styles.unlockProPhotos}>
                    {screens.map((item, index) => (
                    <img
                        key={index}
                        className={styles.unlockProImage}
                        src={item.screen || item.img}
                        alt={`unlockProImg${index + 1}`}
                    />
                    ))}
                </div>
                <div className={styles.unlockProContent}>
                    <div className={styles.unlockProContentTitle}>
                    <h1>{randomText}</h1>
                    <p>
                        Just <span>${monthlyPrice}/month</span>
                    </p>
                    </div>
                    <button
                    onClick={handleOpenBillingPage}
                    >
                    <span>Unlock Pro</span>
                    </button>
                    <div className={styles.unlockProIcons}>
                    <ul className={styles.list}>
                        <li>
                        <img src="/img/imageAppIcon1.jpg" alt="icon" /></li>
                        <li>
                        <img src="/img/imageAppIcon2.jpg" alt="icon2" /></li>
                        <li>
                        <img src="/img/imageAppIcon3.jpg" alt="icon3" /></li>
                        <li>
                        <img src="/img/imageAppIcon4.jpg" alt="icon4" /></li>
                        <div className={styles.unlockProIconsText}>
                        <h3>1800+ Apps</h3>
                        <p>20 new every week</p>
                        </div>
                    </ul>
                    </div>
                </div>
                </div>
            </div>
            </div>
    )
}   

export default ExploreReplayColumnUpgrade;